import type { BootstrapResponse, SaveListResponse, SaveSummary } from "../shared/api-types";
import type { ActionResult, GameAction, GameLogEntry } from "../shared/game-types";
import { apiRequest } from "./client";

export interface ActionResponse extends ActionResult {
  stateVersion: number;
  secondsPerGameYear: number;
}

function savePath(saveId: string, suffix = "") {
  return `/api/saves/${encodeURIComponent(saveId)}${suffix}`;
}

export function listSaves() {
  return apiRequest<SaveListResponse>("/api/saves");
}

export function createSave(civilizationName: string, csrfToken: string, idempotencyKey: string) {
  return apiRequest<SaveSummary>("/api/saves", { method: "POST", body: { civilizationName }, csrfToken, idempotencyKey });
}

export function deleteSave(saveId: string, csrfToken: string) {
  return apiRequest<{ deleted: true }>(savePath(saveId), { method: "DELETE", csrfToken });
}

export function bootstrapGame(saveId: string) {
  return apiRequest<BootstrapResponse>(savePath(saveId, "/bootstrap"));
}

export function submitGameAction(saveId: string, action: GameAction, csrfToken: string, idempotencyKey: string) {
  return apiRequest<ActionResponse>(savePath(saveId, "/action"), {
    method: "POST",
    body: action,
    csrfToken,
    idempotencyKey,
  });
}

export function getGameLog(saveId: string, cursor?: string) {
  const query = new URLSearchParams({ limit: "50" });
  if (cursor) query.set("cursor", cursor);
  return apiRequest<{ items: GameLogEntry[]; nextCursor: string | null }>(`${savePath(saveId, "/log")}?${query}`);
}

export function exportSummary(saveId: string) {
  return apiRequest<Record<string, unknown>>(savePath(saveId, "/export-summary"));
}
